import React from 'react'
const Pages = () => {
  return (
    <div className="content-wrapper pb-0">
      <label>pages</label>
    </div>
  )
}
export default Pages
